module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_2.a6b366b0.png";